export const appMutations = {
	SET_DARK: "SET_DARK",
	SET_DRAWER: "SET_DRAWER",
	TOGGLE_DRAWER: "TOGGLE_DRAWER"
};

export const breadcrumbsMutations = {
	CLEAR: "CLEAR",
	CLEAR_DETAILS: "CLEAR_DETAILS",
	SET: "SET",
	SET_DETAILS: "SET_DETAILS"
};

export const kioskMutations = {
	SET: "SET"
};

export const oneSignalMutations = {
	SET_ID_DEVICE: "SET_ID_DEVICE"
};

export const toastsMutations = {
	REMOVE: "REMOVE",
	SHOW: "SHOW"
};

export const toolbarActionsMutations = {
	ADD: "ADD",
	CLEAR: "CLEAR",
	REMOVE: "REMOVE"
};
